<template>
	<div>

	</div>
</template>

<script>
	import {
		Notify
	} from 'vant';
	import {
		getYuedongAccount,
		loginForWechatCode,
		loginForWechatApp,
		loginForAccount,
		loginFree,
		getPlatformPayWay
	} from '@/request/api';
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex";
	import store from '@/store'
	export default {
		name: 'login',
		computed: mapGetters(['sAccount', 'sToken', 'sUserInfo', 'sCode','sTokenTime']),
		components: {
			[Notify.name]: Notify
		},
		data() {
			return {
			}
		},
		created() {
			this.init()
		},
		
		methods: {
			...mapMutations(['sSetUserInfo', 'sSetToken',"sOrderCode",'sSetCode']),
			init() {
				// this.$router.push('/receipt')
				// return
				let account = this.$getUrlParam("ac");
				let platformCode = this.$getUrlParam("id") ||this.$getUrlParam("platformCode");
				let code = this.$getUrlParam("code")
				let openId = this.$getUrlParam("openId")
				// ticketCode 充值的兑换码密码
				let tc = this.$getUrlParam("tc")
				let mobile = this.$getUrlParam('mobile')
				let sign = this.$getUrlParam('sign')
				// localStorage.setItem('ucode',location.search)
				// document.cookie=`ucode=${location.search}`
				if(mobile && sign){
					loginFree({mobile,sign,platformCode,provider:1}).then((res)=>{
						// if(res.code == 200){
							this.sSetToken(res);
						// }
						
					}).then(()=>{
						getPlatformPayWay({code:platformCode}).then(_res=>{
							if(_res.payTypeH5 && _res.payTypeWx){
								localStorage.setItem('payWay',JSON.stringify({payH5:_res.payTypeH5,payWx:_res.payTypeWx}))
							}else{
								localStorage.setItem('payWay',JSON.stringify({payH5:3,payWx:2}))
							}
						}).then(()=>{
							getYuedongAccount({}).then(res => {
									res.id = mobile
									this.sSetUserInfo(res);
									this.$router.push('loginFree')
								})
						})
					})
					return
				}
				if (!account) {
					// account = this.sAccount
				}
				if(tc){
					this.$router.push("index");
					return;
				}
				let now = new Date().getTime();
				// console.log(now,this.sTokenTime)
				let timeDiff = now - this.sTokenTime;
				//账户登陆
				if (account) {
					if (account == this.sAccount && timeDiff < 30 * 60 * 1000) {
						Notify({
							type: 'success',
							message: '已重新登陆'
						});
					}
					this.getUserInfoForAccount(account,platformCode)
					return;
				}


				//微信公众号登入
				if (!code) {
					code = this.sCode;
				}
				if (code) {
					if(!account && !this.sToken){
						this.$router.push("index");
					}else if(!account && this.sToken){
						this.$router.push("home");
					}
					// if (code == this.sCode && timeDiff < 30 * 60 * 1000) {
					// 	Notify({
					// 		type: 'success',
					// 		message: '已重新登陆'
					// 	});
					// }
					// this.getUserInfoForCode(code);
					return;
				}

				//微信小程序登陆
				if (openId) {
					this.getUserInfoForWechat(openId);
					if (openId == this.sAccount && timeDiff < 30 * 60 * 1000) {
						Notify({
							type: 'success',
							message: '已重新登陆'
						});
					}
					return;
				}
				// console.log(this.sToken,timeDiff)
				if(this.sToken && timeDiff < 30 * 60 * 1000){
					this.$router.push("home");
				}else{
					this.$router.push("index");
				}
				
				//未授权
				// Notify({
				// 	type: 'danger',
				// 	message: '登录过期，请点击链接重新进入！'
				// });
			},
			getUrlParam(name) {
				var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
				let url = window.location.href.split('#')[0]
				let search = url.split('?')[1]
				if (search) {
					var r = search.substring(0).match(reg)
					if (r !== null) return unescape(r[2])
					return null
				} else {
					return null
				}
			},
			//通过token查询用户信息
			getUserInfoForToken(id) {
				getYuedongAccount({

				}).then(res => {
					res.id = id
					this.sSetUserInfo(res);
					this.$router.push("home");
				})
			},


			getUserInfoForCode(code) {
				loginForWechatCode(code).then(res => {
					this.sSetCode(code)
					this.sSetToken(res);
					this.getUserInfoForToken(code);
				})
			},
			getUserInfoForWechat(openId) {
				loginForWechatApp(openId).then(res => {
					this.sSetToken(res);
					this.getUserInfoForToken(openId);
				})
			},
			getUserInfoForAccount(account,platformCode) {
				loginForAccount(account,platformCode).then(res => {
					this.sSetToken(res);
					this.getUserInfoForToken(account);
				})
			},
		}
	}
</script>
